import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthProvider, suppressResizeObserverLoopError } from "common";
import { createHost } from "../host";
import { enforceSessionStorageScope } from "./utils/sessionStorageGuard";

suppressResizeObserverLoopError();

// Drop stale per-message caches when Outlook (VSTO) restarts, before any read.
enforceSessionStorageScope();

const title = "Unicli Assistant";

const rootElement = document.getElementById("container");
const root = createRoot(rootElement);

const host = createHost();
const isVsto = host.kind === "vsto";

const renderBootstrapError = (error) => {
  const message = error instanceof Error ? error.message : String(error);
  root.render(
    <div style={{ padding: 16, fontFamily: "Segoe UI, sans-serif", fontSize: 14 }}>
      <strong>Unicli could not start</strong>
      <p style={{ marginTop: 8, color: "#a4262c" }}>{message}</p>
      {isVsto ? (
        <p style={{ marginTop: 12, color: "#605e5c" }}>
          Check that the dev server is running (<code>npm run dev-server</code> in packages/outlook) and
          rebuild the VSTO add-in if you changed the bridge.
        </p>
      ) : null}
    </div>
  );
};

root.render(
  <div style={{ padding: 16, fontFamily: "Segoe UI, sans-serif", fontSize: 14, color: "#605e5c" }}>
    Starting Unicli…
  </div>
);

host
  .onReady()
  .then(() => {
    root.render(
      <FluentProvider theme={webLightTheme}>
        <AuthProvider>
          <App title={title} host={host} />
        </AuthProvider>
      </FluentProvider>
    );
  })
  .catch(renderBootstrapError);

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(
      <FluentProvider theme={webLightTheme}>
        <AuthProvider>
          <NextApp title={title} host={host} />
        </AuthProvider>
      </FluentProvider>
    );
  });
}
